import { render, staticRenderFns } from "./OrderBreakdown.vue?vue&type=template&id=52983636&scoped=true&"
import script from "./OrderBreakdown.vue?vue&type=script&lang=js&"
export * from "./OrderBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./OrderBreakdown.vue?vue&type=style&index=0&id=52983636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52983636",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VDataTable})
